import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { useTrackableLink } from '@noths/polaris-client-react-hooks';
import * as styles from "./FooterLegal.styles";
import { FeefoAwardBadge } from "../../atoms/FeefoAwardBadge/FeefoAwardBadge";
var currentYear = new Date().getFullYear();
export var FooterLegal = function FooterLegal() {
  var getTrackingEvent = function getTrackingEvent(evt) {
    var _evt$currentTarget$te;
    return {
      event: 'custom_event',
      event_action: 'Legal footer click',
      event_category: 'Footer',
      event_label: (_evt$currentTarget$te = evt.currentTarget.textContent) === null || _evt$currentTarget$te === void 0 ? void 0 : _evt$currentTarget$te.trim()
    };
  };
  var _useTrackableLink = useTrackableLink(),
    trackLinkClick = _useTrackableLink.trackLinkClick,
    trackLinkMouseDown = _useTrackableLink.trackLinkMouseDown;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClient = _useState2[0],
    setIsClient = _useState2[1];
  useEffect(function () {
    setIsClient(true);
  }, []);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    $_css: styles.container
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css2: styles.awardBadge
  }, /*#__PURE__*/React.createElement(FeefoAwardBadge, null)), /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css3: styles.lists
  }, /*#__PURE__*/React.createElement(_StyledUl, {
    $_css4: styles.list
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/sitemap",
    onClick: trackLinkClick(getTrackingEvent),
    onMouseDown: trackLinkMouseDown(getTrackingEvent)
  }, "Sitemap")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/about/privacy-and-cookies",
    onClick: trackLinkClick(getTrackingEvent),
    onMouseDown: trackLinkMouseDown(getTrackingEvent),
    rel: "nofollow"
  }, "Privacy and cookies")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    href: "/about/shopper-terms",
    onClick: trackLinkClick(getTrackingEvent),
    onMouseDown: trackLinkMouseDown(getTrackingEvent),
    rel: "nofollow"
  }, "Terms and conditions"))), /*#__PURE__*/React.createElement(_StyledUl2, {
    $_css5: styles.list
  }, isClient && /*#__PURE__*/React.createElement("li", null, "Copyright \xA9 2006-", currentYear), /*#__PURE__*/React.createElement("li", null, "Notonthehighstreet Enterprises Limited"))));
};
var _StyledDiv = _styled("div")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledDiv2 = _styled2("div")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv3 = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledUl = _styled4("ul")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledUl2 = /*#__PURE__*/_styled5("ul").withConfig({
  displayName: "FooterLegal___StyledUl2",
  componentId: "sc-je2s7b-0"
})(["", ""], function (p) {
  return p.$_css5;
});